export default "__VITE_ASSET__C1G5imU6__"